export default __webpack_public_path__ + "static/media/ic_round-access-time.83d4f670.svg";